export default __webpack_public_path__ + "static/media/Indoor.ede2a53e.svg";